import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=36b02b91&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=36b02b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b02b91",
  null
  
)

export default component.exports